import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { BillingProvider } from "./context/BillingContext";
import { BudgetProvider } from "./context/BudgetContext";
import App from "./app/App";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <BillingProvider>
        <BudgetProvider>
          <App />
        </BudgetProvider>
      </BillingProvider>
    </BrowserRouter>
  </React.StrictMode>
);
